import { useContext } from "react";

import { GlobalContext } from "./globalContext";
import { LocalizationContext } from "./localizationContext";
import { DrupalContext } from "./drupalContext";

export const useGlobalContext = () => useContext(GlobalContext);
export const useLocalizationContext = () => useContext(LocalizationContext);
export const useDrupalContext = () => useContext(DrupalContext);
